import Vue from "vue";
import Vuex from "vuex";

import { alert } from "./alert";
import { account } from "./account";
import { users } from "./user";
import { schedule } from "./schedule";
import { status } from "./status";
import { vehicles } from "./vehicles";
import { customers } from "./customers";
import { sites } from "./sites";
import { plants } from "./plants";
import { report } from "./report";
import { personnels } from "./personnels";
import { jobs } from "./jobs";
import {inventory } from "./inventory";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    alert,
    account,
    users,
    schedule,
    status,
    vehicles,
    customers,
    sites,
    plants,
    report,
    personnels,
    jobs,
    inventory,
  },
});
